import React from "react";
import { createRoot } from "react-dom/client";
import { Changelog } from "changelog";
import { Change } from "types";
import { onPageLoad } from "helpers";

declare const window: {
  changes: Change[];
} & Window;

onPageLoad(() => {
  const reactContainer = document.getElementById("changelog");
  if (!reactContainer) {
    throw new Error("#changelog element not found");
  }

  const changes = window.changes;

  const reactRootElement = createRoot(reactContainer);
  reactRootElement.render(<Changelog changes={changes} />);
});
